'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Button from '@mui/material/Button';
import { DEFAULT_PAGE } from '@/constants/sitemap';

interface Props {
  maxPage: number;
  page: number;
}

const Pagination = (props: Props) => {
  const { maxPage, page } = props;
  const pathname = usePathname();
  const pageUrl = pathname?.split(page.toString())[0];
  const currentPage = page ?? DEFAULT_PAGE;

  const previousPage =
    currentPage > DEFAULT_PAGE
      ? currentPage <= maxPage
        ? currentPage - DEFAULT_PAGE
        : maxPage - DEFAULT_PAGE
      : NaN;
  const nextPage = currentPage < maxPage ? currentPage + DEFAULT_PAGE : NaN;

  const previousPageUrl = previousPage ? `${pageUrl}${previousPage}/` : '';
  const nextPageUrl = nextPage ? `${pageUrl}${nextPage}/` : '';

  return (
    <div className="mt-5 flex justify-end">
      <Button
        className="!mr-2"
        variant="outlined"
        disabled={!previousPageUrl}
        component="a"
        href={previousPageUrl}
        onClick={(e) => !previousPageUrl && e.preventDefault()}
      >
        上一页
      </Button>
      <Button
        variant="outlined"
        disabled={!nextPageUrl}
        component="a"
        href={nextPageUrl || previousPageUrl}
        onClick={(e) => !nextPageUrl && e.preventDefault()}
      >
        下一页
      </Button>
    </div>
  );
};

export default Pagination;
